// hook to refresh the access token 
import axios from 'axios'
import useAuth from './useAuth'

const useRefreshToken = () => {
    const {setAuth}= useAuth()
    const refresh = async()=>{
        
        // console.log(auth);
        const response = await axios.get('/Token/refresh',{ withCredentials: true })
        // .then()
        // .catch(e=>console.log(e))
        setAuth(prev => {   
            console.log(JSON.stringify(prev))
             console.log(response.data.accessToken);
            return {...prev, 
                roles:response.data.roles,
                user:response.data.user,
                accessToken:response.data.accessToken} // gets previous state (on this case access token and  overwrites with the new access token)
        });
        return response.data.accessToken;
    }
  return refresh
}

export default useRefreshToken